<template>
  <div>
    <vx-card class="h-full min-height">
      <div>
        <h4 class="">{{ $t("profile.Settings") }}</h4>
        <vs-divider class="customer-divider my-4" />
      </div>
      <div class="flex w-full vx-row no-gutter justify-center height-300 mt-8">
        <div class="vx-col w-full sm:w-full md:w-full lg:w-10/12 xl:w-3/4">
          <div class="con-exemple-prompt">
            <div
              class="con-vs-tabs vs-tabs tab-menu vs-tabs-warning vs-tabs-position-top"
            >
              <div class="con-ul-tabs">
                <ul class="ul-tabs vs-tabs--ul ul-tabs-fixed">
                  <li
                    class="vs-tabs--li"
                    :class="$route.meta.set_tab == 1 ? 'activeChild' : ''"
                  >
                    <button
                      type="button"
                      class="vs-tabs--btn flex items-center"
                      @click="moveTo('user-settings')"
                    >
                      <i
                        class="vs-icon notranslate icon-scale vs-tabs--btn-icon feather icon-user null vs-icon-warning"
                      ></i
                      ><span>{{
                        $t("profile.Accountsettings.Tab1Title")
                      }}</span>
                    </button>
                  </li>
                  <li
                    class="vs-tabs--li"
                    :class="$route.meta.set_tab == 2 ? 'activeChild' : ''"
                  >
                    <button
                      type="button"
                      class="vs-tabs--btn flex items-center"
                      @click="moveTo('sms-settings')"
                    >
                      <i
                        class="vs-icon notranslate icon-scale vs-tabs--btn-icon feather icon-phone null vs-icon-warning"
                      ></i
                      ><span>{{
                        $t("profile.Accountsettings.Tab2Title")
                      }}</span>
                    </button>
                  </li>
                  <li
                    class="vs-tabs--li"
                    :class="$route.meta.set_tab == 3 ? 'activeChild' : ''"
                  >
                    <button
                      type="button"
                      class="vs-tabs--btn flex items-center"
                      @click="moveTo('languages-settings')"
                    >
                      <i
                        class="vs-icon notranslate icon-scale vs-tabs--btn-icon feather icon-flag null vs-icon-warning"
                      ></i
                      ><span>{{
                        $t("profile.Accountsettings.Tab3Title")
                      }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div class="mt-6" v-if="$route.meta.set_tab == 1">
                <form data-vv-scope="form-1">
                  <div class="mb-4">
                    <label class="vs-input--label" for="first_name"
                      >{{ $t("register.FirstName") }}:</label
                    >
                    <vs-input
                      v-validate="'required'"
                      name="first_name"
                      type="text"
                      :placeholder="$t('register.FirstName')"
                      v-model="first_name"
                      class="w-full"
                      color="warning"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="
                        errors.has('form-1.first_name') && first_name == ''
                      "
                    >
                      {{ $t("form.ErrorMessages.Required") }}
                    </span>
                  </div>
                  <div class="mb-4">
                    <label class="vs-input--label" for="last_name"
                      >{{ $t("register.LastName") }}:</label
                    >
                    <vs-input
                      v-validate="'required'"
                      name="last_name"
                      type="text"
                      :placeholder="$t('register.LastName')"
                      v-model="last_name"
                      color="warning"
                      class="w-full"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('form-1.last_name') && last_name == ''"
                    >
                      {{ $t("form.ErrorMessages.Required") }}
                    </span>
                  </div>
                  <div class="text-center mt-8">
                    <vs-button
                      type="filled"
                      color="warning"
                      class="w-full"
                      @click.prevent="accountSettingsSave"
                      >{{ $t("profile.Accept")
                      }}<feather-icon
                        class="ml-3 bx-spin"
                        :class="isForm1Loading == true ? '' : 'd-none'"
                        icon="LoaderIcon"
                        svgClasses="w-5 h-5"
                      ></feather-icon
                    ></vs-button>
                  </div>
                </form>
              </div>
              <div class="mt-6" v-else-if="$route.meta.set_tab == 2">
                <form data-vv-scope="form-2">
                  <div class="mb-4">
                    <label class="vs-input--label" for="telephone"
                      >{{ $t("login.FormPhone") }}:</label
                    >
                    <div
                      class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
                    >
                      <div class="vs-con-input">
                        <vue-phone-number-input
                          type="tel"
                          class="w-full"
                          @update="changePhoneNumber"
                          name="telephone"
                          v-model="phone_number"
                          :translations="translations"
                          color="#ff9f43"
                          valid-color="#cccccc"
                          default-country-code="TR"
                        />
                      </div>
                      <span
                        class="text-danger text-sm"
                        v-if="requiredPhoNum == false && phone_number !== ''"
                        >{{
                          $t("admin.newUserModal.form.FormTelephoneErr")
                        }}</span
                      >
                      <div class="mt-4 flex">
                        <div class="mr-2">
                          <feather-icon
                            icon="AlertCircleIcon"
                            svgClasses="w-5 h-5"
                            class="text-warning font-bold"
                          ></feather-icon>
                        </div>
                        <div>
                          <small class="font-bold">
                            {{
                              $t("profile.Accountsettings.PhoneWarningMessage")
                            }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center mt-8">
                    <vs-button
                      type="filled"
                      color="warning"
                      class="w-full"
                      @click.prevent="smsSettingsSave"
                      >{{ $t("buttons.Confirm")
                      }}<feather-icon
                        class="ml-3 bx-spin"
                        :class="isForm2Loading == true ? '' : 'd-none'"
                        icon="LoaderIcon"
                        svgClasses="w-5 h-5"
                      ></feather-icon
                    ></vs-button>
                  </div>
                </form>
              </div>
              <div class="mt-6" v-else-if="$route.meta.set_tab == 3">
                <form data-vv-scope="form-3">
                  <div class="mb-4">
                    <label class="vs-input--label" for="languages">{{
                      $t("profile.language.Title", { scolon: ":" })
                    }}</label>
                    <v-select
                      v-validate="'required'"
                      :options="languages_options"
                      :clearable="false"
                      :searchable="false"
                      :placeholder="$t('profile.SelectLanguage')"
                      v-model="currentLang"
                      name="languages"
                    >
                      <template #no-options>
                        <div>
                          {{ $t("form.Empty") }}
                        </div>
                      </template>
                    </v-select>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('form-3.languages') && !currentLang"
                      >{{ $t("form.ErrorMessages.Required") }}</span
                    >
                  </div>
                  <div class="text-center mt-8">
                    <vs-button
                      type="filled"
                      color="warning"
                      class="w-full"
                      @click.prevent="languagesSettingsSave"
                      >{{ $t("profile.Accept")
                      }}<feather-icon
                        class="ml-3 bx-spin"
                        :class="isForm3Loading == true ? '' : 'd-none'"
                        icon="LoaderIcon"
                        svgClasses="w-5 h-5"
                      ></feather-icon
                    ></vs-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-prompt
      color="warning"
      type="confirm"
      :active.sync="activeConfirm"
      not-close
      :title="$t('profile.Accountsettings.ConfirmationCode')"
      :buttons-hidden="true"
    >
      <div class="con-content-scroll px-4 pt-4 pb-6">
        <div class="text-center mb-4">
          {{ $t("profile.Accountsettings.ConfirmationCodeMessage") }}
        </div>
        <div class="flex justify-center">
          <OtpInput
            ref="otpInput"
            input-classes="otp-input vs-input--input"
            separator="-"
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
          />
        </div>
        <span
          class="text-danger text-center text-sm"
          v-show="validateSubmitted == true && code.length < 6"
        >
          {{ $t("profile.Accountsettings.MissingCodeError") }}
        </span>
        <div class="mt-5 flex justify-center">
          <div class="w-full mr-3">
            <vs-progress
              :percent="time"
              :color="progressbarcolor"
            ></vs-progress>
          </div>
          <div class="text-center" style="width:45px">
            {{ countdown }}
          </div>
        </div>
      </div>
      <div class="mt-4">
        <vs-button
          type="filled"
          color="warning"
          class="w-full mb-3"
          @click="validateNotificationSettings"
          >{{ $t("buttons.Approve")
          }}<feather-icon
            class="ml-3 bx-spin"
            :class="isApproveCodeLoading == true ? '' : 'd-none'"
            icon="LoaderIcon"
            svgClasses="w-5 h-5"
          ></feather-icon
        ></vs-button>
        <vs-button
          type="filled"
          color="warning"
          class="w-full mb-3"
          :disabled="tryagainBtnDisabled"
          @click="tryAgainCode"
          >{{ $t("buttons.Tryagain")
          }}<feather-icon
            class="ml-3 bx-spin"
            :class="isTrAgainLoading == true ? '' : 'd-none'"
            icon="LoaderIcon"
            svgClasses="w-5 h-5"
          ></feather-icon
        ></vs-button>
        <vs-button
          type="filled"
          color="primary"
          class="w-full"
          @click="activeConfirmCancel"
          >{{ $t("buttons.Cancel") }}</vs-button
        >
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import i18n from '../../i18n/i18n.js'
import vSelect from 'vue-select'
import OtpInput from '@bachdgvn/vue-otp-input'
import moment from 'moment-timezone'

import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
  components:{
    'vue-phone-number-input': VuePhoneNumberInput,
    vSelect,
    VuePhoneNumberInput,
    OtpInput
  },
  data () {
    return {
      first_name: '',
      last_name: '',
      languages_options: [
        { label: i18n.t('profile.language.Tr'), value: 'tr' },
        { label: i18n.t('profile.language.En'), value: 'en' }
      ],
      currentLang: { label: i18n.t('profile.language.Tr'), value: 'tr' },
      lastLang: this.$i18n.locale,
      phone_number: '',
      phoneNumber: '',
      translations: {
        countrySelectorLabel: i18n.t(
          'admin.newUserModal.form.TelephoneCountryCode'
        ),
        countrySelectorError: i18n.t(
          'admin.newUserModal.form.TelephoneCountryCodeError'
        ),
        phoneNumberLabel: i18n.t('admin.newUserModal.form.Telephone'),
        example: i18n.t('admin.newUserModal.form.TelephoneExample')
      },
      requiredPhoNum: true,
      phoneFormatFirst: false,
      controlTelefone: false,
      activeConfirm: false,
      time: 0,
      setIntervalTimer: null,
      progressbarcolor: 'success',
      isApproveCodeLoading: false,
      code: '',
      codeControl: false,
      tryagainBtnDisabled: true,
      isTrAgainLoading: false,
      validateSubmitted: false,
      isForm1Loading: false,
      isForm2Loading: false,
      isForm3Loading: false,
      langSett: false,
      setTab: 1,
      countdown: '02:00'
    }
  },
  computed: {
    userMeInfo () {
      return this.$store.getters.returnUserMeInfo
    }
  },
  mounted () {
    const that = this
    this.languages_options.filter(function (x) {
      if (x.value === that.$i18n.locale) {
        that.currentLang = x
      }
    })
    this.getUserData()

    if (this.$route.path === '/profile') {
      this.$router.push('/profile/user-settings').catch(() => {})
    }
    clearInterval(this.setIntervalTimer)
  },
  methods: {
    getUserData () {
      this.$store
        .dispatch('userMeInfo')
        .then(() => {
          this.last_name = this.userMeInfo.last_name
          this.first_name = this.userMeInfo.first_name
          this.phoneFormatFirst = false
          this.phoneNumber = this.userMeInfo.contact_info
            ? this.userMeInfo.contact_info
            : ''
          this.phone_number = this.userMeInfo.contact_info
            ? this.userMeInfo.contact_info.slice(3)
            : ''
        })
        .catch((error) => {
          this.errorMsg(error)
        })
    },

    accountSettingsSave () {
      this.$validator.validateAll('form-1').then((result) => {
        if (result) {
          if (
            this.userMeInfo.first_name !== this.first_name ||
            this.userMeInfo.last_name !== this.last_name
          ) {
            this.isForm1Loading = true
            this.editUserInfo()
          } else {
            this.isForm1Loading = false
            this.$vs.notify({
              title: i18n.t('notifyAlert.success.title'),
              text: i18n.t('profile.Accountsettings.SuccessMessage'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success',
              position: 'top-right'
            })
          }
        }
      })
    },

    languagesSettingsSave () {
      this.$validator.validateAll('form-3').then((result) => {
        if (result) {
          this.isForm3Loading = true
          window.localStorage.setItem('userLang', this.currentLang.value)
          this.lastLang = this.currentLang.value
          this.$router.go()
        }
      })
    },

    smsSettingsSave () {
      this.$validator.validateAll('form-2').then((result) => {
        if (result && this.requiredPhoNum === true) {
          this.isForm2Loading = true
          if (
            this.phoneNumber &&
            this.phoneNumber !== this.userMeInfo.contact_info
          ) {
            this.notificationSettings()
          } else {
            this.isForm2Loading = false
          }
        }
      })
    },
    handleOnComplete (value) {
      this.code = value
      this.codeControl = true
    },
    handleOnChange (value) {
      if (value.length < 6) {
        this.codeControl = false
      }
      this.code = value
    },
    tryAgainCode () {
      this.isTrAgainLoading = true
      this.notificationSettings()
    },
    notificationSettings () {
      this.$store
        .dispatch('notificationSettings', {
          phone_number: this.phoneNumber
        })
        .then(() => {
          this.isForm2Loading = false
          this.isTrAgainLoading = false
          this.activeConfirm = true
          this.tryagainBtnDisabled = true
          this.time = 0
          this.progressbarcolor = 'success'
          clearInterval(this.setIntervalTimer)
          this.timer()
        })
        .catch((error) => {
          this.isForm2Loading = false
          this.isTrAgainLoading = false

          let errorMessage = ''

          if (Object.prototype.hasOwnProperty.call(error.response.data, 'error_code') && error.response.data.error_code === 400) {
            errorMessage = i18n.t(
              'profile.Accountsettings.ConfirmationCode400Message'
            )
          } else if (error.response.status === 404) {
            errorMessage = i18n.t(
              'profile.Accountsettings.ConfirmationCode400Message'
            )
          } else {
            this.errorMsg(error)
          }

          if (errorMessage !== '') {
            this.$vs.notify({
              title: i18n.t('notifyAlert.error.title'),
              text: errorMessage,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            })
          } else {
            this.errorMsg(error)
          }
        })
    },

    validateNotificationSettings () {
      this.validateSubmitted = true
      if (this.codeControl === true) {
        this.isApproveCodeLoading = true
        this.$store
          .dispatch('validateNotificationSettings', this.code)
          .then(() => {
            this.isApproveCodeLoading = false
            this.activeConfirm = false
            clearInterval(this.setIntervalTimer)
            this.$vs.notify({
              title: i18n.t('notifyAlert.success.title'),
              text: i18n.t(
                'profile.Accountsettings.ValidateCodeSuccessMessage'
              ),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success',
              position: 'top-right'
            })
          })
          .catch((error) => {
            this.isApproveCodeLoading = false
            let errorMessage = ''

            if (error.response.status === 404) {
              errorMessage = i18n.t(
                'profile.Accountsettings.ConfirmationCode400Message'
              )
            } else {
              this.errorMsg(error)
            }

            if (errorMessage !== '') {
              this.$vs.notify({
                title: i18n.t('notifyAlert.error.title'),
                text: errorMessage,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
                position: 'top-right'
              })
            } else {
              this.errorMsg(error)
            }
          })
      }
    },

    activeConfirmCancel () {
      this.code = ''
      clearInterval(this.setIntervalTimer)
      this.progressbarcolor = 'success'
      this.activeConfirm = false
    },

    timer () {
      const self = this
      let seconds = 1000
      this.setIntervalTimer = setInterval(function () {
        seconds = seconds + 1000
        if (self.time < 100) {
          self.time = (seconds * 100) / 120000
        }
        if (seconds >= 100000) {
          self.progressbarcolor = 'danger'
        }

        if (seconds === 120000) {
          self.tryagainBtnDisabled = false
          clearInterval(self.setIntervalTimer)
        }
        self.countdown = moment(120000 - seconds).format('mm:ss')
      }, 1000)
    },

    editUserInfo () {
      this.$store
        .dispatch('editUserInfo', {
          first_name: this.first_name,
          last_name: this.last_name
        })
        .then((response) => {
          this.isForm1Loading = false
          this.last_name = response.data.last_name
          this.first_name = response.data.first_name
          this.$vs.notify({
            title: i18n.t('notifyAlert.success.title'),
            text: i18n.t('profile.Accountsettings.SuccessMessage'),
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.errorMsg(error)
        })
    },

    changePhoneNumber (payload) {
      if (payload.isValid === true) {
        this.requiredPhoNum = true
        this.phoneNumber = payload.formattedNumber
      } else {
        if (!payload.phoneNumber) {
          this.requiredPhoNum = true
        } else {
          this.requiredPhoNum = false
        }
        this.phoneNumber = ''
      }
    },

    moveTo (link) {
      this.$router.push(`/profile/${  link}`).catch(() => {})
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  },
  watch: {
    userMeInfo () {
      this.last_name = this.userMeInfo.last_name
      this.first_name = this.userMeInfo.first_name
      this.phoneNumber = this.userMeInfo.contact_info
        ? this.userMeInfo.contact_info
        : ''
      this.phone_number = this.userMeInfo.contact_info
        ? this.userMeInfo.contact_info.slice(3)
        : ''
    }
  },
  beforeDestroy () {
    clearInterval(this.setIntervalTimer)
  }
}
</script>
<style lang="scss">
.otp-input {
  height: 40px;
  width: 40px;
  font-size: 1.4rem;
  text-align: center;
  margin: 0px 5px;
}

.tab-menu {
  .vs-tabs--btn {
    justify-content: center;
  }
  .activeChild .vs-tabs--btn {
    border-bottom: 1px solid rgba(var(--vs-warning), 1) !important;
  }

  .con-tab.vs-tabs--content {
    padding: 0px;
    .country-selector__list {
      min-height: 150px !important;
      height: 150px !important;
    }
  }

  @media (max-width: 991.78px) {
    .vs-tabs--btn {
      text-align: center;
      span {
        display: none;
      }
    }
  }
}
.min-height {
  min-height: 600px;
}
</style>

